import React from 'react';
import { AwardIcon, MapPinnedIcon } from 'lucide-react';
import { AboutPageHero } from '../components/AboutPageHero';
const team = [{
  name: 'Pema Dorje',
  role: 'Lead Mountain Guide',
  image: 'https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?auto=format&fit=crop&w=900&q=85',
  bio: 'Born in the Nubri Valley, Pema has spent two decades guiding in Manaslu and knows its weather, language, and trails by instinct.'
}, {
  name: 'Maya Gurung',
  role: 'Guest & Operations Director',
  image: 'https://images.unsplash.com/photo-1581403341630-a6e0b9d2d257?auto=format&fit=crop&w=900&q=85',
  bio: 'Maya coordinates every detail from Kathmandu to the trailhead, balancing calm precision with an unmistakably generous welcome.'
}, {
  name: 'Nima Lama',
  role: 'Senior Trek Leader',
  image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=900&q=85',
  bio: 'Nima combines a rigorous approach to altitude management with a gift for making every guest feel part of the mountain community.'
}, {
  name: 'Tsering Gurung',
  role: 'Logistics & Camp Manager',
  image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=900&q=85',
  bio: 'From equipment checks to the first cup of tea, Tsering makes the demanding work of a high mountain journey feel effortless.'
}];
export function TeamPage() {
  return <main className="w-full bg-[#f7f4ed] text-[#233a32]" data-id="element-655" data-mp="3lvc1xusmc23h">
      <AboutPageHero eyebrow="The people of Manaslu Trekking" title="Experienced hands. Open hearts." description="Our guides and operations team bring decades of mountain knowledge, thoughtful preparation, and a genuine love for sharing their home." imageUrl="https://images.unsplash.com/photo-1519681393784-d120267933ba?auto=format&fit=crop&w=2000&q=85" data-id="element-656" data-mp="3qsu14tgu32ya" />

      <section className="mx-auto max-w-5xl px-6 py-16 text-center sm:py-24" data-id="element-657" data-mp="1f188leyxwhyg">
        <p className="mx-auto max-w-3xl text-base leading-8 text-[#53645b]" data-id="element-658" data-mp="1dlmc5x8bd8kq">
          We are a close team of mountain professionals. Behind every departure
          is a network of guides, drivers, cooks, lodge hosts, and porters whose
          care and judgement shape the experience from beginning to end.
        </p>
      </section>

      <section className="mx-auto max-w-6xl px-6 pb-20 sm:pb-28" data-id="element-659" data-mp="zne7t48y74zj">
        <div className="grid gap-x-8 gap-y-14 sm:grid-cols-2" data-id="element-660" data-mp="1wc3st3fvgdpq">
          {team.map(member => <article key={member.name} data-id="element-661" data-mp="1rchf6sw4svge">
              <img src={member.image} alt={`Portrait of ${member.name}`} className="aspect-[4/3] w-full object-cover" data-id="element-662" data-mp="1reu4jr47y83h" />
              <div className="mt-5 border-l-2 border-[#a98b50] pl-5" data-id="element-663" data-mp="1ijxkg3iynb0u">
                <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#9a7b3e]" data-id="element-664" data-mp="2f2ldckqjw300">
                  {member.role}
                </p>
                <h2 className="mt-2 font-serif text-3xl" data-id="element-665" data-mp="2a9ik6dpoqvkc">{member.name}</h2>
                <p className="mt-3 max-w-lg text-sm leading-7 text-[#53645b]" data-id="element-666" data-mp="3szxu6v2ov4bk">
                  {member.bio}
                </p>
              </div>
            </article>)}
        </div>
      </section>

      <section className="border-y border-[#d9d0bf] bg-[#efe9dc]" data-id="element-667" data-mp="5scbz71hkdb9">
        <div className="mx-auto grid max-w-5xl gap-8 px-6 py-14 sm:grid-cols-2" data-id="element-668" data-mp="att8yrgunfmk">
          <div className="flex gap-4" data-id="element-669" data-mp="fscyf1unj9jo">
            <MapPinnedIcon className="mt-1 h-5 w-5 shrink-0 text-[#9a7b3e]" aria-hidden="true" data-id="element-670" data-mp="frbjunefg4x7" />
            <div data-id="element-671" data-mp="phmokc5xqi55">
              <h2 className="font-serif text-2xl" data-id="element-672" data-mp="ph4mgywld9pb">
                Local knowledge, shared generously
              </h2>
              <p className="mt-2 text-sm leading-7 text-[#53645b]" data-id="element-673" data-mp="ti6mhhyc1psc">
                Our people have a personal relationship with the routes,
                cultures, and changing conditions of the region.
              </p>
            </div>
          </div>
          <div className="flex gap-4" data-id="element-674" data-mp="puozjabzcr23">
            <AwardIcon className="mt-1 h-5 w-5 shrink-0 text-[#9a7b3e]" aria-hidden="true" data-id="element-675" data-mp="ptndybxc8m64" />
            <div data-id="element-676" data-mp="kvc5o5moyjq0">
              <h2 className="font-serif text-2xl" data-id="element-677" data-mp="ktrgywn25v02">Professional by nature</h2>
              <p className="mt-2 text-sm leading-7 text-[#53645b]" data-id="element-678" data-mp="zjqdkuyysydf">
                Training, experience, and care are present in every briefing,
                decision, and mountain day.
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>;
}